//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import emitter from 'element-ui/src/mixins/emitter'
export default {
  name: 'CySelect',
  mixins: [emitter],
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    allowCreate: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    },
    url: [String],
    items: {
      type: Array
    },
    value: [String, Array, Number]
  },
  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },
  data () {
    return {
      itemList: [],
      selectItem: {},
      myValue: this.value,
      myPlaceholder: this.placeholder
    }
  },
  created () {
    if (!this.$Utils.IsEmpty(this.url)) {
      this.queryList()
    } else {
      this.itemList = this.items
    }
  },
  watch: {
    url: function (newValue) {
      this.queryList()
    },
    items: function (newValue) {
      this.itemList = newValue
    },
    value: function (newValue, oldValue) {
      this.myValue = newValue
    },
    myValue: function (newValue, oldValue) {
      this.$emit('input', newValue)
    },
    selectItem: function (newValue) {
      this.$emit('on-select-change', newValue)
    },
    placeholder: function (newValue, oldValue) {
      if (this.$Utils.IsEmpty(newValue)) {
        this.myPlaceholder = '请选择'
      } else {
        this.myPlaceholder = newValue
      }
    }
  },
  methods: {
    queryList: function () {
      let that = this
      console.log(that.url)
      if (!that.$Utils.IsEmpty(that.url)) {
        that.$axiosWeb.post(that.url, null, {params: {loading: false}}).then(function (res) {
          if (res.meta.success) {
            that.itemList = res.data
          } else {
            that.$Message.error(res.meta.message)
          }
        })
      }
    },
    onSelect: function (value) {
      let that = this
      if (that.$Utils.IsEmpty(value)) {
        that.selectItem = null
      } else {
        let item = that.itemList.filter(function (item) {
          return item.value === value
        })
        that.selectItem = item[0]
      }
      this.dispatch('ElFormItem', 'el.form.change', [value])
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/select/CySelect.vue